/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  StaticWrapper,
  RichText,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  CardLayered,
  CardVertical,
  CardCarouselContainer,
  CardHorizontalMini,
  Media,
} from '@marriott/mi-common-static-components';
import { EditableHTLWrapper } from '@marriott/mi-common-static-components';
import {
  WelcomeDetailEditable,
  GuestDetailsEditable,
  HeaderEditable,
  LTHeaderEditable,
  LTHeroBanner,
  DiningDetail,
  ExperienceDetails,
  ThankyouDetail,
  Submit,
  LTPromo,
  CardHorizontalFeature,
  MiniCardCarouselContainer,
  CommitmentIcons,
  HeroGallery,
  Section,
  ExploreLocations,
  LTLocations,
} from '@marriott/mi-martech-components';
import { Footer, LTFooter, LTStatistics, StoryTilesContainer } from '@marriott/mi-martech-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import {
  AccountContainerEditable,
  SignInEditable as AccountSignInEditable,
  SignInContentBlockEditable,
} from '@marriott/mi-account-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/foundation/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-martech/components/welcomedetail`]: WelcomeDetailEditable,
  [`mi-aem-martech/components/footer`]: Footer,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-martech/components/diningdetails`]: DiningDetail,
  [`mi-aem-martech/components/guestdetails`]: GuestDetailsEditable,
  [`mi-aem-martech/components/experience`]: ExperienceDetails,
  [`mi-aem-martech/components/header`]: HeaderEditable,
  [`mi-aem-martech/components/thankyou`]: ThankyouDetail,
  [`mi-aem-martech/components/submit`]: Submit,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-martech/components/container`]: Container,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/content/media`]: Media,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  // Love Travels components mapping
  [`mi-aem-martech/components/lovetravels/header`]: LTHeaderEditable,
  [`mi-aem-martech/components/lovetravels/hero`]: LTHeroBanner,
  [`mi-aem-martech/components/lovetravels/promo`]: LTPromo,
  [`mi-aem-martech/components/lovetravels/footer`]: LTFooter,
  [`mi-aem-martech/components/lovetravels/featuredcard`]: CardLayered,
  [`mi-aem-martech/components/lovetravels/cardvertical`]: CardVertical,
  [`mi-aem-martech/components/lovetravels/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-martech/components/lovetravels/storytiles`]: StoryTilesContainer,
  [`mi-aem-martech/components/lovetravels/cardminicarouselcontainer`]: MiniCardCarouselContainer,
  [`mi-aem-martech/components/lovetravels/commitmenticons`]: CommitmentIcons,
  [`mi-aem-martech/components/lovetravels/statistics`]: LTStatistics,
  [`mi-aem-martech/components/lovetravels/hero-gallery`]: HeroGallery,
  [`mi-aem-martech/components/lovetravels/locations`]: LTLocations,
  [`mi-aem-martech/components/lovetravels/section`]: Section,
  [`mi-aem-martech/components/lovetravels/explorelocations`]: ExploreLocations,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: AccountSignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
};

export const AEM_REACT_TITLE_MAPPING = {
  'mi-aem-common-spa/components/foundation/staticwrapper': 'Static Wrapper',
  'mi-aem-common-spa/components/content/richtext': 'Rich Text',
  'mi-aem-martech/components/welcomedetail': 'Welcome Detail',
  'mi-aem-martech/components/footer': 'Footer Component',
  'mi-aem-common-spa/components/content/cardcarouselcontainer': 'Card Carousel Container',
  'mi-aem-martech/components/diningdetails': 'Dining Details',
  'mi-aem-martech/components/guestdetails': 'Guest Details',
  'mi-aem-martech/components/experience': 'Experience Page Component',
  'mi-aem-martech/components/header': 'Header Component',
  'mi-aem-martech/components/thankyou': 'Thank You',
  'mi-aem-martech/components/submit': 'Submit',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-martech/components/container': 'Container',
  'mi-aem-homepage-spa/components/content/global-navigation': 'Global Navigation',
  'mi-aem-homepage-spa/components/content/utilityNavigation': 'Utility Navigation',
  'mi-aem-homepage-spa/components/content/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/content/media': 'Media',
  'mi-aem-common-spa/components/content/cardhorizontalmini': 'Card Horizontal Mini-Standard',
  'mi-aem-martech/components/lovetravels/header': 'Love Travels - Header Component',
  'mi-aem-martech/components/lovetravels/hero': 'Love Travels - Hero',
  'mi-aem-martech/components/lovetravels/promo': 'Love Travels - Promo',
  'mi-aem-martech/components/lovetravels/footer': 'Love Travels - Footer Component',
  'mi-aem-martech/components/lovetravels/featuredcard': 'Love Travels - Featured Card',
  'mi-aem-martech/components/lovetravels/cardvertical': 'Love Travels - Card Vertical',
  'mi-aem-martech/components/lovetravels/cardhorizontalfeature': 'Love Travels - Card Horizontal Feature',
  'mi-aem-martech/components/lovetravels/storytiles': 'Love Travels - Story Tiles',
  'mi-aem-martech/components/lovetravels/cardminicarouselcontainer': 'Love Travels - Card Mini Carousel Container',
  'mi-aem-martech/components/lovetravels/commitmenticons': 'Love Travels - Commitment Icons',
  'mi-aem-martech/components/lovetravels/statistics': 'Love Travels - Statistics',
  'mi-aem-martech/components/lovetravels/hero-gallery': 'Love Travels - Hero Gallery',
  'mi-aem-martech/components/lovetravels/locations': 'Love Travels - Locations',
  'mi-aem-martech/components/lovetravels/section': 'Love Travels - Section',
  'mi-aem-martech/components/lovetravels/explorelocations': 'Love Travels - Explore Locations',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (allowedComponents, isAuthorMode, pageProps, languageSelectorModal) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
    MapTo(`mi-aem-common-spa/components/foundation/staticwrapper`)(StaticWrapper, {
      emptyLabel: 'StaticWrapper',
      isEmpty: false,
    });

    MapTo(`mi-aem-martech/components/lovetravels/cardminicarouselcontainer`)(props => (
      <MiniCardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));

    MapTo(`mi-aem-martech/components/container`)(Container, {
      emptyLabel: 'Container',
      isEmpty: false,
    });

    MapTo(`mi-aem-martech/components/lovetravels/cardhorizontalfeature`)(props => (
      <CardHorizontalFeature {...props} isAuthorMode={isAuthorMode} />
    ));

    MapTo(`mi-aem-martech/components/lovetravels/commitmenticons`)(CommitmentIcons);
    MapTo(`mi-aem-martech/components/lovetravels/statistics`)(LTStatistics);
    MapTo(`mi-aem-martech/components/lovetravels/hero-gallery`)(HeroGallery);
    MapTo(`mi-aem-martech/components/lovetravels/section`)(props => (
      <Section {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-martech/components/lovetravels/explorelocations`)(props => (
      <ExploreLocations {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));

    MapTo(`mi-aem-martech/components/lovetravels/locations`)(props => (
      <LTLocations {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));

    MapTo(`mi-aem-martech/components/header`)(
      // other props...
      props => {
        const { model } = pageProps;

        return (
          <HeaderEditable
            {...props}
            propertyName={model?.accData?.property_config?.hotel_name}
            propertyAddress={model?.accData?.property_config?.hotel_location}
            headerLogo={model?.accData?.property_config?.logo_url}
            hotelEmail={model?.accData?.property_config?.hotel_contact_email}
            hotelPhoneNumber={
              model?.accData?.property_config?.phone_number
                ? `+${model.accData.property_config.phone_number.country_code} ${model.accData.property_config.phone_number.area_code} ${model.accData.property_config.phone_number.phone_number}`
                : ''
            }
            confirmationNumber={pageProps?.productSpecificResponse?.reservation?.confirmationNumber}
            brandCode={model?.accData?.property_config?.brand_cd}
            sessionData={pageProps?.sessionData}
            brandName={model?.accData?.property_config?.brand_name}
            isAuthorMode={isAuthorMode}
            enableDynamicLocaleRequest={pageProps.enableDynamicLocaleRequest}
            enableSignIn={pageProps.enableSignInRequest}
            languageSelectorModal={languageSelectorModal}
            sessionData1={pageProps?.sessionData}
            env={pageProps?.env}
            property_config={pageProps?.model?.accData?.property_config}
            rewardMember={
              pageProps?.productSpecificResponse?.reservation?.marriottRewardsMemberFlg ||
              pageProps?.productSpecificResponse?.reservation?.isMemberFlg
            }
            levelCd={pageProps?.productSpecificResponse?.reservation?.levelCd}
          />
        );
      },
      {
        emptyLabel: 'Header',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/lovetravels/header`)(
      // other props...
      props => {
        return <LTHeaderEditable {...props} languageSelectorModal={languageSelectorModal} />;
      },
      {
        emptyLabel: 'Love Travels Header',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/lovetravels/promo`)(props => (
      <LTPromo {...props} allowedComponents={allowedComponents} />
    ));

    MapTo(`mi-aem-common-spa/components/content/media`)(Media);
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);

    MapTo(`mi-aem-martech/components/welcomedetail`)(
      props => (
        <WelcomeDetailEditable
          {...props}
          {...pageProps?.model?.accData}
          i18nMap={pageProps?.model?.i18n}
          errorMessage={pageProps?.errorVal}
          propertyName={pageProps?.model?.accData?.property_config?.hotel_name}
          propertyAddress={pageProps?.model?.accData?.property_config?.hotel_location}
          backgroundImage={pageProps?.model?.accData?.property_config?.background_image_url}
          hotelEmail={pageProps?.model?.accData?.property_config?.hotel_contact_email}
          brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
          hotelPhoneNumber={
            pageProps?.model?.accData?.property_config?.phone_number
              ? `+${pageProps.model.accData.property_config.phone_number.country_code} ${pageProps.model.accData.property_config.phone_number.area_code} ${pageProps.model.accData.property_config.phone_number.phone_number}`
              : ''
          }
          amenities={pageProps?.model?.accData?.property_config?.amenities}
          reservation={pageProps?.productSpecificResponse?.reservation}
          passions={pageProps?.productSpecificResponse?.passions}
          isAuthorMode={pageProps?.isAuthorMode}
          errorData={pageProps?.productSpecificResponse?.accDown}
          favIcon={pageProps?.model?.favIcon}
        />
      ),
      {
        emptyLabel: 'Welcome Detail',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-martech/components/footer`)(
      props => (
        <Footer
          {...props}
          propertyName={pageProps?.model?.accData?.property_config?.hotel_name}
          property_config={pageProps?.model?.accData?.property_config}
          propertyAddress={pageProps?.model?.accData?.property_config?.hotel_location}
          brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
        />
      ),
      {
        emptyLabel: 'Footer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-martech/components/lovetravels/footer`)(props => <LTFooter {...props} />, {
      emptyLabel: 'Love Travels Footer',
      isEmpty: false,
    });

    MapTo(`mi-aem-martech/components/lovetravels/featuredcard`)(props => <CardLayered {...props} />);
    MapTo(`mi-aem-martech/components/lovetravels/cardvertical`)(
      props => <CardVertical {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'CardVertical',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(
      props => <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'CardCarouselContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/lovetravels/storytiles`)(
      props => <StoryTilesContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'StoryTilesContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/diningdetails`)(
      props => (
        <>
          <DiningDetail
            {...props}
            backgroundImage={pageProps?.model?.accData?.property_config?.background_image_url}
            i18nMap={pageProps?.model?.i18n}
            property_config={pageProps?.model?.accData?.property_config}
            brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
            brandName={pageProps?.model?.accData?.property_config?.brand_name}
            reservation={pageProps?.productSpecificResponse?.reservation}
          />
        </>
      ),
      {
        emptyLabel: 'Dining Detail',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/lovetravels/hero`)(LTHeroBanner);

    MapTo(`mi-aem-martech/components/guestdetails`)(
      props => (
        <GuestDetailsEditable
          {...props}
          {...pageProps?.model?.accData}
          i18nMap={pageProps?.model?.i18n}
          errorMessage={pageProps?.errorVal}
          propertyName={pageProps?.model?.accData?.property_config?.hotel_name}
          propertyAddress={pageProps?.model?.accData?.property_config?.hotel_location}
          hotelEmail={pageProps?.model?.accData?.property_config?.hotel_contact_email}
          brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
          hotelPhoneNumber={
            pageProps?.model?.accData?.property_config?.phone_number
              ? `+${pageProps.model.accData.property_config.phone_number.country_code} ${pageProps.model.accData.property_config.phone_number.area_code} ${pageProps.model.accData.property_config.phone_number.phone_number}`
              : ''
          }
          amenities={pageProps?.model?.accData?.property_config?.amenities}
          reservation={pageProps?.productSpecificResponse?.reservation}
          passions={pageProps?.productSpecificResponse?.passions}
          isAuthorMode={pageProps?.isAuthorMode}
          errorData={pageProps?.productSpecificResponse?.accDown}
          backgroundImage={pageProps?.model?.accData?.property_config?.background_image_url}
          property_config={pageProps?.model?.accData?.property_config}
          requestId={pageProps?.requestId}
          operationSignatures={pageProps?.operationSignatures}
          sessionData1={pageProps?.sessionData}
          favIcon={pageProps?.model?.favIcon}
          productSpecificResponse={pageProps?.productSpecificResponse}
        />
      ),
      {
        emptyLabel: 'Guest Detail',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/experience`)(
      props => (
        <>
          <ExperienceDetails
            {...props}
            backgroundImage={pageProps?.model?.accData?.property_config?.background_image_url}
            i18nMap={pageProps?.model?.i18n}
            property_config={pageProps?.model?.accData?.property_config}
            brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
            brandName={pageProps?.model?.accData?.property_config?.brand_name}
            reservation={pageProps?.productSpecificResponse?.reservation}
          />
        </>
      ),
      {
        emptyLabel: 'Experience Details',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/thankyou`)(
      props => (
        <>
          <ThankyouDetail
            {...props}
            backgroundImage={pageProps?.model?.accData?.property_config?.background_image_url}
            i18nMap={pageProps?.model?.i18n}
            enableMBTACallout={pageProps?.enableMBTACallout}
            property_config={pageProps?.model?.accData?.property_config}
            reservation={pageProps?.productSpecificResponse?.reservation}
            brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
          />
        </>
      ),
      {
        emptyLabel: 'Thankyou Details',
      }
    );

    MapTo(`mi-aem-martech/components/submit`)(
      props => (
        <Submit
          {...props}
          submitURL={pageProps.submissionURL}
          backgroundImage={pageProps?.model?.accData?.property_config?.background_image_url}
          i18nMap={pageProps?.model?.i18n}
          property_config={pageProps?.model?.accData?.property_config}
          brandCode={pageProps?.model?.accData?.property_config?.brand_cd}
          brandName={pageProps?.model?.accData?.property_config?.brand_name}
          reservation={pageProps?.productSpecificResponse?.reservation}
          enableConsentCheckbox={pageProps.enableConsentCheckbox}
          requestId={pageProps?.requestId}
          operationSignatures={pageProps?.operationSignatures}
          isAuthorMode={pageProps?.isAuthorMode}
          sessionData1={pageProps?.sessionData}
        />
      ),
      {
        emptyLabel: 'Submit',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-martech/components/signin`)(props => <AccountSignInEditable {...props} />, {
      emptyLabel: 'signin',
      isEmpty: false,
    });

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <AccountSignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    const ExperienceFragmentVariationConfig = {
      emptyLabel: 'Experience Fragment',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };

    MapTo(`mi-aem-martech/components/content/experience-fragments`)(props => {
      return <Container isInEditor {...props} isPage={false} model={respGridUtil(props?.model)} />;
    }, ExperienceFragmentVariationConfig);

    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
      props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'NavigationContainerWrapper',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
      emptyLabel: 'NavigationUtilityLinkWrapper',
      isEmpty: false,
    });
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
      emptyLabel: 'NavigationWrapper',
      isEmpty: false,
    });

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.split(baseModelPath)[1];

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
